import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/feature/ScrollToTop';
import SEOHead from '@/components/feature/SEOHead';
import HeroSection from './components/HeroSection';
import TrendingSection from './components/TrendingSection';
import CategorySection from './components/CategorySection';
import UpdateSection from './components/UpdateSection';
import ArticleSection from './components/ArticleSection';
import FAQSection from './components/FAQSection';

const homeSchema = {
  '@context': 'https://schema.org',
  '@graph': [
    {
      '@type': 'Organization',
      name: '91影视',
      url: 'https://www.91yingshi.com',
      description: '海量高清影视资源免费在线观看平台',
      foundingDate: '2018',
      contactPoint: {
        '@type': 'ContactPoint',
        email: 'contact@91yingshi.com',
        contactType: 'customer service',
        availableLanguage: ['Chinese'],
      },
    },
    {
      '@type': 'WebSite',
      name: '91影视',
      url: 'https://www.91yingshi.com',
      potentialAction: {
        '@type': 'SearchAction',
        target: 'https://www.91yingshi.com/search?q={search_term_string}',
        'query-input': 'required name=search_term_string',
      },
    },
    {
      '@type': 'WebPage',
      name: '91影视 - 海量高清影视资源免费在线观看',
      description:
        '91影视提供海量高清电影、电视剧、综艺、动漫在线免费观看，资源丰富、更新及时、无需注册即可畅享。',
      url: 'https://www.91yingshi.com',
      isPartOf: { '@type': 'WebSite', name: '91影视', url: 'https://www.91yingshi.com' },
    },
  ],
};

export default function Home() {
  return (
    <>
      <SEOHead schema={homeSchema} />
      <ScrollToTop />
      <div className="min-h-screen bg-background-50">
        <Navbar />
        <main>
          <HeroSection />
          <TrendingSection />
          <CategorySection />
          <UpdateSection />
          <ArticleSection />
          <FAQSection />
        </main>
        <Footer />
      </div>
    </>
  );
}